import React, { Component, Fragment } from "react";
import uuid from "uuid";
import CartList from "./cartList";
import { productData } from "./productData";
import DisplayProducts from "./displayProducts";

class ProductsList extends Component {
  state = {
    productData: "",
    cartItems: ""
  };

  componentDidMount = () => {
    this.fetchProductsData(productData);
  };

  fetchProductsData = data => {
    this.setState({ productData: data });
  };

  addCartItems = data => {
    //Adding new instance of the data Object
    //Adding unique cartId to filter them
    let copyData = Object.assign({}, data);
    copyData.cartId = uuid.v4();
    this.setState({
      cartItems: [...this.state.cartItems, copyData]
    });
  };

  filterCartItems = itemId => {
    this.setState({
      cartItems: this.state.cartItems.filter(item => {
        return item.cartId !== itemId;
      })
    });
  };

  render() {
    if (this.state.productData === "") {
      return <div>Loading...</div>;
    }

    const { cartItems } = this.state;
    return (
      <Fragment>
        <CartList
          cartItems={cartItems}
          filterCartItems={this.filterCartItems}
        />
        <div className="container">
          {productData.products.map(data => {
            return (
              <DisplayProducts
                data={data}
                {...this.state}
                key={data.id}
                addCartItems={this.addCartItems}
              />
            );
          })}
        </div>
      </Fragment>
    );
  }
}

export default ProductsList;
